export const SET_DRIVERS = 'SET_DRIVERS';
export const SET_DRIVERS_LOADING = 'SET_DRIVERS_LOADING';
export const ADD_DRIVER = 'ADD_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';
export const DELETE_DRIVER = 'DELETE_DRIVER';
